<div class="sc-upload-container">
  @if (!file) {
    <div class="sc-upload-empty"
         (click)="selectFile()"
         (dragover)="onDragOver($event)"
         (drop)="onDragDrop($event)">
      <div class="sc-upload-label">
        <i class="fas fa-cloud-upload-alt"></i>
        <div i18n>Upload a file</div>
        <input #fileInput
               type="file"
               [accept]="accept"
               [multiple]="false"
               [disabled]="disabled"
               (change)="onFileSelect($event)">
      </div>
      <div class="sc-upload-format"
           i18n>
        {{ accept }} - FORMAT
      </div>
    </div>
  }

  @if (file) {
    <div class="sc-upload-file-selected">
      <div class="sc-upload-clear-block">
        <p-button icon="pi pi-times"
                  styleClass="p-button-rounded p-button-text sc-upload-clear-button"
                  (onClick)="clearFile($event)"
                  [disabled]="uploading">
        </p-button>
      </div>
      <div class="sc-upload-selected-file-block">
        <div>
          @if (!uploading) {
            <i [ngClass]="['sc-selected-file-icon', fileIconClass]">
            </i>
          }
          @if (uploading) {
            <sc-progress-circle [progress]="progress$ | async">
            </sc-progress-circle>
          }
        </div>
        <div class="sc-upload-selected-file-info">
          <div class="sc-file-name-label">{{ file.name }}</div>
          <div class="sc-file-size-label">{{ file.size | fileSize }}</div>
        </div>
      </div>
    </div>
  }

  @if (errors?.length) {
    <div class="flex flex-col">
      @for (error of errors; track error; let first = $first) {
        <p-message [severity]="error.severity"
                   [ngClass]="{ 'mt-4': !first }">
          {{ error.summary }}
        </p-message>
      }
    </div>
  }
</div>